import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import axios from 'axios';

// Função para exibir Toast
const showToastify = (message) => {
  Toastify({
    text: message,
    duration: 4000,
    gravity: "top",
    position: "center",
    close: true,
    style: {
      background: "#ccab78", 
      color: "black",
      borderRadius: "999px",
      padding: "12px 24px",
      fontFamily: "inherit",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
    },
    className: "toastify-custom",
  }).showToast();
};

const formOuvidoria = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const formElement = document.getElementById('form-ouvidoria');
    const telefoneInput = document.getElementById('telefone');
    const btnAssunto = document.getElementById('btn-assunto');
    const dropdown = document.getElementById('dropdown');
    const badgeAssunto = document.getElementById('badge-assunto');
    const checkboxInputs = dropdown?.querySelectorAll('input[type="checkbox"]');

    if (!formElement || !telefoneInput || !btnAssunto || !dropdown) return;

    // Abrir/fechar dropdown
    btnAssunto.addEventListener('click', () => {
      dropdown.classList.toggle('hidden');
    });

    // Fechar dropdown ao clicar fora
    document.addEventListener('click', (e) => {
      if (!btnAssunto.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.classList.add('hidden');
      }
    });

    // Atualiza badge e texto do botão
    const updateAssuntoDisplay = () => {
      const selected = Array.from(checkboxInputs)
        .filter(input => input.checked)
        .map(input => input.nextElementSibling.textContent.trim());

      const textSpan = btnAssunto.querySelector('span');
      if (selected.length > 0) {
        textSpan.textContent = selected.join(', ');
        badgeAssunto.textContent = selected.length;
        badgeAssunto.classList.remove('hidden');
      } else {
        textSpan.textContent = 'Selecione...';
        badgeAssunto.classList.add('hidden');
      }
    };

    checkboxInputs.forEach(input => {
      input.addEventListener('change', updateAssuntoDisplay);
    });

    // Máscara de telefone
    telefoneInput.addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 11) value = value.slice(0, 11);

      let formatted = '';
      if (value.length > 0) formatted += `(${value.slice(0, 2)}`;
      if (value.length >= 3) formatted += `) ${value.slice(2, 3)}`;
      if (value.length >= 4) formatted += ` ${value.slice(3, 7)}`;
      if (value.length >= 8) formatted += `-${value.slice(7, 11)}`;

      e.target.value = formatted;
    });

    formElement.addEventListener("submit", function (e) {
      e.preventDefault();

      const nome = document.getElementById('nome')?.value.trim();
      const email = document.getElementById('email')?.value.trim();
      const telefone = telefoneInput?.value.trim();
      const mensagem = document.getElementById('mensagem')?.value.trim();

      const assuntoSelecionado = Array.from(checkboxInputs)
        .filter(input => input.checked)
        .map(input => input.value);

      if (!nome || !email || !telefone || !mensagem || assuntoSelecionado.length === 0) {
        showToastify("Por favor, preencha todos os campos.");
        return;
      }

      const telefoneValido = /^\(\d{2}\)\s\d?\s?\d{4}-\d{4}$/.test(telefone);
      const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!telefoneValido) {
        showToastify("Telefone inválido. Use o formato (99) 9 9999-9999.");
        return;
      }

      if (!emailValido) {
        showToastify("E-mail inválido.");
        return;
      }

      const form_data = {
        nome,
        email,
        telefone,
        mensagem,
        assunto: assuntoSelecionado // envia como array
      };

      const btnSubmit = formElement.querySelector("button[type=submit]");
      if (btnSubmit) btnSubmit.disabled = true;

      axios.post("/formulario-ouvidoria/", form_data)
        .then(response => {
          showToastify(response.data?.message || "Enviado com sucesso!");
          formElement.reset();
          checkboxInputs.forEach(input => input.checked = false);
          updateAssuntoDisplay();
        })
        .catch(error => {
          const msg = error.response?.data?.message || "Erro ao enviar o formulário.";
          showToastify(msg);
        })
        .finally(() => {
          if (btnSubmit) setTimeout(() => btnSubmit.disabled = false, 1000);
        });
    });
  });
};

export default formOuvidoria;
